import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { InternationalService } from '@root/international.service';
import { OperateSidebarService } from '../operate-sidebar.service';
import { DateService } from '@root/shared/service/date.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import _ from 'lodash';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@root/shared/service/translate.service';
import { SearchDateAndHouseComponent } from '@root/component/search-components/search-date-and-house/search-date-and-house.component';
import {
  SwitchPageService,
  PAGES_NAME,
  PageName,
} from '@root/router/component/order-detail-sidebar/switch-page.service';
import { ModalService } from '@root/router/index/modal.service';
import { getBytesLength } from '@root/util/util';
import { MultiHouseCalendarService } from '../../calendar/multi-house-calendar/multi-house-calendar.service';
interface HouseItem {
  house_id: number;
  title: string;
  check_in: Moment;
  check_out: Moment;
  price: number;
}

interface Data {
  date: any;
  house: {
    id: string;
    house_title: string;
  };
}

@Component({
  selector: 'host-hour-room-order',
  templateUrl: './hour-room-order.component.html',
  styleUrls: ['./hour-room-order.component.scss'],
})
export class HourRoomOrderComponent implements OnInit {
  @Input() data: Data;
  @ViewChild('paidAmount') paidAmount: ElementRef;
  _house;
  listOfChannels = [];
  listOfIncomeMethod = [];
  listOfCurrency = [];
  @Output() success = new EventEmitter();
  nzFormat = this.dateService.getAngularFormat([null, 'hm']);
  form: UntypedFormGroup = this.fb.group({
    reservation_type: 'hour_reservation',
    name: ['', Validators.required],
    mobile: '',
    // number_of_guests: 1,
    channel: [null, Validators.required],
    // price: [null, Validators.required],
    currency_type: this.international.getCurrency(),
    commission: null,
    price: null,
    note: '',
    paid_amount: '',
    payment_method: null,
    hour_reservation_start: [
      '', // moment().hour(12).minute(0).toDate(),
      Validators.required,
    ],
    hour_reservation_end: [
      '', // moment().hour(15).minute(0).toDate(),
      Validators.required,
    ],
    client_id: '',
  });
  // listOfHouse: Array<HouseItem> = [];
  listOfHourOrder = [];
  checkinOrder = null;
  checkoutOrder = null;
  noteStatus: 'none' | 'editing' = 'none';
  checking = false;
  hasDuplicateGuest = false;
  isExistedGuest = false;
  get house() {
    return this._house;
  }
  set house(value) {
    this._house = value;

    const v = this.form.value;
    // const originStart = v.hour_reservation_start;
    // const originEnd = v.hour_reservation_end;
    const currentStart = moment(value.check_in).hour(12).minute(0).toDate();
    const currentEnd = moment(value.check_in).hour(15).minute(0).toDate();

    this.form.patchValue({
      hour_reservation_start: currentStart,
      hour_reservation_end: currentEnd,
    });
  }

  get houseFee() {
    return this.form.get('price').value;
  }

  private compositionFlag = false;

  constructor(
    private fb: UntypedFormBuilder,
    private international: InternationalService,
    private httpService: OperateSidebarService,
    private houseCalendarService: MultiHouseCalendarService,
    private dateService: DateService,
    private translate: TranslateService,
    private modalService: NzModalService,
    private globalModalService: ModalService,
    private switchPageService: SwitchPageService
  ) {}

  ngOnInit() {
    const data = this.data ? this.data : this.houseCalendarService.hourReservationData;
    const date = moment(data.date);
    const house = data.house;

    this.house = {
      house_id: house.id,
      title: house.house_title,
      check_in: date,
      check_out: date,
      price: null,
    };
    // const _house = {
    //   house_id: house.id,
    //   title: house.house_title,
    //   check_in: date,
    //   check_out: date,
    //   price: null,
    // };
    // this.listOfHouse = [_house];

    this.requestCurrencyList();
    this.requestConfig();
    this.requestHourOrders();

    // const house = {
    //   house_id: this.house.id,
    //   title: this.house.house_title,
    //   check_in: moment(this.dateRange[0]),
    //   check_out: moment(this.dateRange[0]),
    //   price: null,
    // };
  }

  isFormValid() {
    this.checking = true;

    const paidAmount = +this.form.get('paid_amount').value;
    if (_.isNil(paidAmount) || paidAmount === 0) {
      return this.form.valid;
    } else {
      return this.form.valid && !_.isNil(this.form.get('payment_method').value);
    }
  }

  compositionstart(control) {
    console.log('composition start');
    this.compositionFlag = true;
  }
  compositionend(control) {
    console.log('composition end');
    this.compositionFlag = false;
    this.checkIfHasDuplicateGuest(control);
  }

  checkIfHasDuplicateGuest(control?) {
    if (this.compositionFlag) {
      return;
    }

    const value = this.form.value;
    const limit = control === 'mobile' ? 5 : 3;
    if (value.name || value.mobile) {
      if (getBytesLength(value[control]) >= limit) {
        this.requestDuplicateGuests();
      }
    } else {
      this.hasDuplicateGuest = false;
    }
  }

  requestDuplicateGuests() {
    const value = this.form.value;
    const params = {
      page: '1',
      page_size: '100',
      format: 'reservation_add_client',
      search_arr: `${value.name || ''},${value.mobile || ''},,`,
    };

    this.httpService.fetchGuestList(params).subscribe((res) => {
      if (res.data.list && res.data.list.length) {
        this.hasDuplicateGuest = true;
      } else {
        this.hasDuplicateGuest = false;
      }
    });
  }

  requestCurrencyList() {
    this.httpService.fetchCurrencyList().subscribe((res) => {
      this.listOfCurrency = _.get(res, 'data.currency_list');
    });
  }

  requestConfig() {
    this.httpService.fetchConfig().subscribe((res) => {
      const channelList = _.get(res, 'data.reservation_channel') || [];
      const incomeMethodList = _.get(res, 'data.income_method') || [];
      this.listOfChannels = _.filter(channelList, (item) => !item.delete_time);

      this.listOfIncomeMethod = _.filter(incomeMethodList, (item) => !item.delete_time);
    });
  }

  requestHourOrders() {
    const house_id = _.get(this.house, 'house_id');
    const check_in = _.get(this.house, 'check_in').format('YYYY-MM-DD');

    this.httpService.fetchHourOrders({ house_id, check_in }).subscribe((res) => {
      this.listOfHourOrder = _.get(res, 'data.hour_reservations') || [];
      this.checkinOrder = _.get(res, 'data.checkin_reservation');
      this.checkoutOrder = _.get(res, 'data.checkout_reservation');
    });
  }

  requestCreateManualOrder() {
    const value = this.form.value;
    const hour_reservation_start = moment(value.hour_reservation_start).format('HH:mm');
    const hour_reservation_end = moment(value.hour_reservation_end).format('HH:mm');
    const status = value.paid_amount > 0 ? 1 : 0;
    const commission = value.commission === null ? 0 : value.commission;

    const reservations = [
      {
        house_id: this.house.house_id,
        price: value.price,
        check_in: this.house.check_in.format('YYYY-MM-DD'),
        check_out: this.house.check_out.format('YYYY-MM-DD'),
      },
    ];

    const params = {
      ...value,
      hour_reservation_start,
      hour_reservation_end,
      reservations,
      status,
      commission,
    };
    this.httpService.createManualOrder(params).subscribe((res) => {
      console.log('create: ', res);
      if (res.error_code === 0) {
        this.refreshCalendar();
        this.success.emit();
      }
    });
  }

  displayDuplicateGuestModal() {
    const value = this.form.value;
    const modal = this.globalModalService.displayDuplicateGuestModal({
      guestInfo: { name: value.name, phone: value.mobile },
    });
    modal.afterClose.subscribe((res) => {
      console.log('close res: ', res);
      if (!res) {
        return;
      }

      const { type, data } = res;

      if (type === 'onClickExistGuest') {
        this.isExistedGuest = true;
      } else {
        this.isExistedGuest = false;
      }
      this.form.patchValue({ client_id: data.id, name: data.name, mobile: data.phone });
    });
  }

  displayPickerModal(house) {
    const params = {
      defaultDate: {
        begin: house.check_in.format('YYYY-MM-DD'),
        end: house.check_out.format('YYYY-MM-DD'),
      },
      defaultHouses: [house.house_id],
      dateType: 'single',
    };

    const modal = this.modalService.create({
      nzTitle: this.translate.syncGet('component.sidebar.choose_house_and_date'),
      nzWidth: 900,
      nzContent: SearchDateAndHouseComponent,
      nzFooter: null,
      nzComponentParams: params as any,
    });

    modal.afterClose.subscribe((result) => {
      console.log('result: ', result);
      if (!result) {
        return;
      }

      const { date, houses } = result;
      const house = houses[0];
      this.house = {
        house_id: house.id,
        title: house.title,
        check_in: moment(date.begin),
        check_out: moment(date.end),
        price: null, // price由form控制
      };
      // this.listOfHouse = houses.map((house) => ({
      //   house_id: house.id,
      //   title: house.title,
      //   check_in: moment(date.begin),
      //   check_out: moment(date.end),
      //   price: null, // price由form控制
      // }));

      this.requestHourOrders();
    });
  }

  private isConflict() {
    if (!this.listOfHourOrder) {
      return false;
    }

    const { hour_reservation_start, hour_reservation_end } = this.form.value;
    // const rstart = moment(`${date} ${hour_reservation_start}`);
    // const rend = moment(`${date} ${hour_reservation_end}`);

    return this.listOfHourOrder.some((order) => {
      const date = moment(order.check_in).format('YYYY-MM-DD');
      const start = moment(`${date} ${order.hour_reservation_start_time}`).format('YYYY-MM-DD HH:mm');
      const end = moment(`${date} ${order.hour_reservation_end_time}`).format('YYYY-MM-DD HH:mm');

      return this.isTimeConflict(hour_reservation_start, hour_reservation_end, start, end);
    });
  }

  private isTimeConflict(leftStartTime, leftEndTime, rightStartTime, rightEndTime) {
    return (
      moment(rightStartTime).isBetween(leftStartTime, leftEndTime, 'm', '[)') ||
      moment(leftStartTime).isBetween(rightStartTime, rightEndTime, 'm', '[)') ||
      moment(leftEndTime).isBetween(rightStartTime, rightEndTime, 'm') ||
      moment(rightEndTime).isBetween(leftStartTime, leftEndTime, 'm')
    );
  }

  private checkForm() {
    if (!this.isFormValid()) {
      return;
    }

    if (this.isConflict()) {
      this.modalService.confirm({
        // nzTitle: '入离时间段与其他小时房订单冲突，确定保存吗？',
        nzTitle: this.translate.syncGet('warn.sidebar.hour_order_conflict'),
        nzOnOk: () => this.requestCreateManualOrder(),
      });
    } else {
      this.requestCreateManualOrder();
    }
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  onInputFocus() {
    const { price = 0, commission = 0 } = this.form.value;
    if (!_.isNil(price)) {
      this.form.patchValue({ paid_amount: price - commission });
      this.paidAmount.nativeElement.select();
    }
  }

  onClickReservation(code) {
    /** unimplement */
    this.switchPageService.navigate(PageName.OrderDetail, { code, index: 0, backArrow: true });

    /** @deprecated */
    // this.switchPageService.createNewLianBiao({
    //   page: PAGES_NAME.HOUR_ORDER_DETAIL_BASIC,
    //   code: code,
    //   tab: 0,
    //   showBack: true
    // });
    this.success.emit();
  }

  onClickSave() {
    this.checkForm();
    // this.requestCreateManualOrder();
  }

  onClickCancel() {
    this.success.emit();
  }
}
